import { render, staticRenderFns } from "./BespokeShow.vue?vue&type=template&id=2e3e23bb&scoped=true&"
import script from "./BespokeShow.vue?vue&type=script&lang=js&"
export * from "./BespokeShow.vue?vue&type=script&lang=js&"
import style0 from "./BespokeShow.vue?vue&type=style&index=0&id=2e3e23bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3e23bb",
  null
  
)

export default component.exports